const data = [
    {
        name: "Akash Kumawat",
        ImageUrl: "/Team/Advisors/Akash_Choudhary.jpg",
        position: ["Event Advisor", "Finance Advisor"],
        facebookLink: "https://www.facebook.com/share/16o3VWisDt/",
        linkedinLink: "https://www.linkedin.com/in/akash-kumawat-5281aa370"
    },
    {
        name: "Rajat Singh",
        ImageUrl: "/Team/Advisors/Rajat.jpg",
        position: "Event Advisor",
        facebookLink: "https://www.facebook.com/share/1AASt621Z7/",
        linkedinLink: "https://www.linkedin.com/in/rajat-singh-694284314",
        InstagramLink: "https://www.instagram.com/rajatkaviya/"
    },
    {
        name: "Bhavesh Meena",
        ImageUrl: "/Team/Advisors/Bhavesh_Meena.png",
        position: "Design Advisor",
        facebookLink:"https://www.facebook.com/profile.php?id=61565317714576",
        linkedinLink: "https://www.linkedin.com/in/bhavesh-meena-11619b343/",
        InstagramLink: "https://www.instagram.com/bhavezyy/"
    },
    {
        name: "Nandini",
        ImageUrl: "/Team/Advisors/Nandini.jpg",
        position: ["Design Advisor", "Event Advisor"],
        facebookLink: "https://www.facebook.com/share/16jbJwydob/",
        linkedinLink: "https://www.linkedin.com/in/nandini-916732326?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        InstagramLink: "https://www.instagram.com/nandiniagar22/"
    },
    {
        name: "Kaustubh Tambi",
        ImageUrl: "/Team/Advisors/Kaushtubh_Tambi.jpg",
        position: ["Design Advisor", "Web Development Advisor"],
        facebookLink: "https://www.facebook.com/share/1CdMoNFGX3/",
        linkedinLink: "https://www.linkedin.com/in/kaustubh-tambi-393279316?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        InstagramLink: "https://www.instagram.com/kxustubh_09/"
    },{
        name: "Prayag Choudhary",
        ImageUrl: "/Team/Advisors/Prayag_Choudhary.jpg",
        position: "Sponsorship Advisor",
        facebookLink: "https://www.facebook.com/share/15qtJhH17m/",
        linkedinLink: "https://www.linkedin.com/in/prayag-choudhary-875362330?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        InstagramLink: "https://www.instagram.com/prayagchoudhary_/"
    },
    {
        name: "Nikita Ameriya",
        ImageUrl: "/Team/Advisors/Nikita_Ameriya.jpg",
        position: "Sponsorship Advisor",
        facebookLink: "https://www.facebook.com/share/1PhTnKFKNY/",
        linkedinLink: "https://www.linkedin.com/in/nikita-ameriya-b73630315?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        InstagramLink: "https://www.instagram.com/nikitaameriya7/"
    },
    {
        name: "Anil Dhaker",
        ImageUrl: "/Team/Advisors/Anil_Dhakar.jpg",
        position: "Sponsorship Advisor",
        facebookLink: "https://www.facebook.com/share/19TpUy6Sy6/",
        linkedinLink: "https://www.linkedin.com/in/anil-dhaker-067b10312/",
        InstagramLink: "https://www.instagram.com/_anil_dhaker_007/"
    },
    {
        name: "Poonam Choudhary",
        ImageUrl: "/Team/Advisors/Poonam_Choudhary.jpg",
        position: "Public Relations Advisor",
        facebookLink: "https://www.facebook.com/share/1bVwhPeh6U/",
        linkedinLink: "https://www.linkedin.com/in/poonam-choudhary-487550330?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        InstagramLink: "https://www.instagram.com/poonam_choudhary_1859/"
    },
    {
        name: "Sahil Chhimpa",
        ImageUrl: "/Team/Advisors/Sahil_Chhimpa.jpg",
        position: "Public Relations Advisor",
        facebookLink: "https://www.facebook.com/share/1B3B4Y4RRn/",
        linkedinLink: "https://www.linkedin.com/in/sahil-chhimpa-078b44324",
        InstagramLink: "https://www.instagram.com/sahil_chhimpa08/"
    }
]

export default data